"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _underscore = require("underscore");

var _newSearch = _interopRequireDefault(require("../../assets/icons/new-search.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SearchField,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = SearchField = function () {
  var SearchField =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SearchField, _React$Component);

    function SearchField() {
      var _this;

      _classCallCheck(this, SearchField);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchField).apply(this, arguments));
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(SearchField, [{
      key: "onChange",
      value: function onChange(evt) {
        var ref, term;
        boundMethodCheck(this, SearchField);
        term = (ref = evt.target) != null ? ref.value : void 0;
        return (this.props.onChange || this.debouncedSearch)(term);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("span", {
          className: "SearchField"
        }, _react.default.createElement("input", {
          type: "search",
          onChange: this.onChange,
          defaultValue: this.props.value,
          placeholder: this.props.placeholder || 'Search'
        }), _react.default.createElement(_newSearch.default, {
          className: "input-icon-left"
        }));
      }
    }]);

    return SearchField;
  }(_react.default.Component);

  ;
  SearchField.propTypes = {
    value: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    onChange: _propTypes.default.func
  };
  SearchField.prototype.debouncedSearch = (0, _underscore.debounce)(function (term) {
    if (term) {
      return window.location.href = "/explore?query=".concat(term.replace(/\s+/, '+'));
    }
  }, 500);
  return SearchField;
}.call(void 0);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/search-field/index.js
// module id = 1387
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16